import React from 'react';
import '../css/BioSection.css';

const BioSection: React.FC = () => {
    return (
        <section id="bio">
            <div className='max-width'>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;From the mysterious land of the Andes  mountains
                    comes the face of the next generation of New Wave,
                    shaking the air waves in search of redemption.<br /><br />
                    Retired Latin Lover. Man of a Million Mistakes.<br /><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;His name?<br /><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;Saadin Dassum.<br /><br />
                    &nbsp;&nbsp;&nbsp;&nbsp;Ecuadorian Miami-based artist Saadin Dassum has his sights set on "Rock in Spanglish", a
                    soulful reflection of his first ten years as a Latin lover in Miami. The album explores the
                    acoustics of the Latin pop and Merengue that molded Dassum's childhood experience in
                    Ecuador, and marries those sounds with the dance rock edge that he has honed through his
                    musical career.
                    <br /><br />
                </p>
            </div>
        </section>
    );
};

export default BioSection;